<template>
  <div class="sys-tree">
    <div class="el-search vue-top-padding radius">
      <div class="el-left">
        <el-button
          type="primary"
          size="small"
          v-hasPerm="['sys:menu:insert']"
          icon="el-icon-plus"
          @click="appendNode"
          >{{ $t("common.add") }}</el-button
        >
      </div>
    </div>
    <div class="vue-padding radius">
      <el-table
        :data="menuList"
        :empty-text="$t('common.noData')"
        v-loading="loading"
        :element-loading-text="$t('common.loading')"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column
          prop="name"
          :label="$t('menu.name')"
          width="250"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column prop="icon" :label="$t('menu.icon')" width="100" :align="'center'">
          <template slot-scope="scope">
            <span :class="scope.row.icon"></span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('menu.type')" width="100" :align="'center'">
          <template slot-scope="scope">
            <el-tag size="medium" v-if="scope.row.type === 0">{{ $t("menu.direct") }}</el-tag>
            <el-tag size="medium" v-if="scope.row.type === 1" type="success">{{ $t("menu.menu") }}</el-tag>
            <el-tag size="medium" v-if="scope.row.type === 2" type="warning">{{ $t("menu.btn") }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('menu.component')"
          prop="component"
          :show-overflow-tooltip="true"
          width="168"
          :align="'center'"
        ></el-table-column>
        <!-- 开发时方便 -->
        <!-- <el-table-column
					:label="$t('authority.Menu.9398615-0')"
					prop="authority"
					:show-overflow-tooltip="true"
					:align="'center'"
				>
					<template #default="scope">
						<el-button size="small" @click="$tools.copy(scope.row.authority)"
							>复制</el-button
						>
					</template>
				</el-table-column> -->
        <el-table-column
          :label="$t('menu.menuUrl')"
          prop="url"
          :show-overflow-tooltip="true"
          width="200"
          :align="'center'"
        ></el-table-column>
        <el-table-column :label="$t('menu.path')" :show-overflow-tooltip="true" width="260" :align="'center'">
          <template slot-scope="scope">
            <span v-if="scope.row.path && scope.row.component">{{
              scope.row.path + "/" + url(scope.row.component)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="enabled" :label="$t('menu.state')" width="100" :align="'center'">
          <template slot-scope="scope">
            <el-tag
              size="medium"
              @click="tagEnabled(scope.$index, scope.row)"
              :type="String(scope.row.enabled) === '1' ? 'success' : 'warning'"
            >
              {{ String(scope.row.enabled) === "1" ? $t("common.enable") : $t("common.disable") }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" :label="$t('menu.sort')" width="100" :align="'center'"></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('menu.createTime')"
          width="160"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          :label="$t('common.operate')"
          fixed="right"
          :width="$i18n.locale == 'zh_CN' ? 210 : 220"
          :align="'center'"
        >
          <template slot-scope="scope">
            <el-button size="mini" v-hasPerm="['sys:menu:update']" @click="modify(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button
              size="mini"
              type="primary"
              v-hasPerm="['sys:menu:insert']"
              :disabled="scope.row.type && scope.row.type === 2"
              @click="append(scope.row)"
              >{{ $t("common.add") }}</el-button
            >
            <el-button size="mini" type="danger" v-hasPerm="['sys:menu:delete']" @click="remove(scope.row)">{{
              $t("common.delete")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加路由弹框 -->
      <v-add-menu
        :dialogAddMenu="dialogAddMenu"
        :isMenuProp="isMenuProp"
        :nodeData="nodeData"
        :selectId="selectId"
        :menuList="addMenuList"
        :langList="langList"
        v-on:closeDialogAddMenu="closeDialogAddMenu"
        v-on:updateMenu="updateMenu"
      >
      </v-add-menu>
    </div>
  </div>
</template>

<script>
  import vAddMenu from "@/components/authority/menu/AddMenu";
  import lineUtil from "@/utils/humpToLine";

  export default {
    name: "Menu",
    components: { vAddMenu },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    data() {
      return {
        menuList: [], // 菜单树结构
        addMenuList: [{ id: "0", label: this.$t("menu.main"), children: [] }],
        loading: false,
        dialogAddMenu: false, // 是否显示添加菜单弹框
        isMenuProp: false, // 不同层级菜单校验字段不一致
        nodeData: {
          component: "",
          enabled: "",
          icon: "",
          id: "",
          label: "",
          type: "",
          names: [{ lang: "", name: "", key: Date.now() }],
          path: "",
          pId: "",
          sort: "",
          authority: "",
          url: ""
        },
        selectId: "",
        node: "",
        currentKey: Number,
        checkUrlList: [],
        langList: []
      };
    },
    mounted() {
      this.loadMenu();
      this.listLang();
    },
    methods: {
      loadMenu() {
        this.loading = true;
        this.$api
          .request(this.$url.AuthorityMenu.list)
          .then(res => {
            if (res.code === 0) {
              this.menuList = res.data;
              this.addLabel(this.menuList);
              this.addMenuList[0].children = res.data;
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 传入一个数组 数组内对象添加元素label 若数组内对象含有children 则递归调用
      addLabel(arr) {
        arr.forEach(item => {
          if (item.children && item.children.length > 0) {
            item.label = item.name;
            this.addLabel(item.children);
          } else {
            item.label = item.name;
          }
        });
      },
      listLang() {
        this.$api.dict("sys_lang_list").then(res => {
          if (res.code === 0) {
            this.langList = res.data;
          }
        });
      },

      url(str) {
        return lineUtil.toLine(str);
      },

      append(data) {
        // 添加菜单
        if (data.type && data.type === 2) {
          this.$message.warning(this.$t("menu.next"));
        } else {
          Object.keys(this.nodeData).forEach(key => {
            if (key === "enabled" || key === "type") {
              this.nodeData[key] = "1";
            } else {
              if (key === "pId") {
                this.selectId = data.id;
              } else {
                this.nodeData[key] = "";
              }
            }
          });
          this.dialog();
          let children = data.children;
          this.nodeData.names = [{ lang: "zh_CN", name: "", key: Date.now() }];
          this.nodeData.sort = children && children.length > 0 ? children.length + 1 : 1;
        }
      },

      keysNode(data) {
        Object.keys(this.nodeData).forEach(key => {
          if (key !== "children" && key !== "meta") {
            if (key === "enabled" || key === "type") {
              this.nodeData[key] = String(data[key]);
            } else {
              this.nodeData[key] = data[key];
            }
          }
        });
        this.nodeData.names = [{ lang: "zh_CN", name: "", key: Date.now() }];
      },

      tagEnabled(index, row) {
        let enabled = String(row.enabled) === "1" ? "0" : "1";
        let text = enabled === "1" ? this.$t("menu.show") : this.$t("menu.hide");
        this.$confirm(
          String(row.pId) === "0"
            ? this.$t("common.definite") + text + this.$t("menu.allMenu")
            : this.$t("common.definite") + text + this.$t("menu.thisMenu"),
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            let array = [row.id];
            if (String(row.pId) === "0") {
              this.delMenu(array, row);
            }
            let obj = { enabled: enabled, menuIdList: array };
            this.$api
              .request(this.$url.AuthorityMenu.updateInMenu, this.$method.put, obj)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t("menu.success"));
                  this.loadMenu();
                }
              })
              .catch(() => {
                this.$message.success(this.$t("menu.error"));
              });
          })
          .catch(() => {
            this.$message.info(this.$t("menu.cancel"));
          });
      },

      updateMenu(tips) {
        // 暂时通过重新加载菜单的方式来显示修改状态
        this.$message.success(tips);
        this.loadMenu();
      },

      modify(data) {
        // 修改菜单
        this.keysNode(data);
        this.selectId = data.pId;
        this.dialog();
      },

      dialog() {
        this.dialogAddMenu = !this.dialogAddMenu;
      },

      remove(data) {
        // 删除菜单
        this.$confirm(
          String(data.pId) === "0" ? this.$t("menu.allDelete") : this.$t("menu.delete"),
          this.$t("common.tip"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        ).then(() => {
          let array = [data.id];
          if (String(data.pId) === "0") {
            this.delMenu(array, data);
          }
          this.$api
            .request(this.$url.AuthorityMenu.delete, this.$method.delete, {
              menuIdList: array
            })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t("menu.deleteSuccess"));
                this.loadMenu();
              }
            });
        });
      },

      delMenu(array, data) {
        // 递归将要删除的菜单及子菜单添加到数组中
        if (data && data.children) {
          for (let i = 0; i < data.children.length; i++) {
            array.push(data.children[i].id);
            let children = data.children[i];
            if (children.children && children.children.length > 0) {
              this.delMenu(children.children);
            }
          }
        }
      },

      appendNode() {
        // 开启添加菜单弹框
        this.dialog();
        this.selectId = "0";
        this.nodeData.enabled = "1";
        this.nodeData.type = "0";
        this.nodeData.names = [{ lang: "zh_CN", name: "", key: Date.now() }];
        this.nodeData.sort = this.menuList.length + 1;
      },

      closeDialogAddMenu(dialogAddMenu) {
        // 关闭添加菜单弹框
        this.dialogAddMenu = dialogAddMenu;
      }
    }
  };
</script>

<style lang="scss">
  @import "~@/assets/scss/tree";
</style>
